export enum INVOICE_TYPE {
	ACCOUNT = 'ACCOUNT',
	INVOICE = 'INVOICE',
}

export enum PAYMENT_TYPE {
	CHEQUE_DEPOSIT = 'CHEQUE',
	BANK_TRANSFER = 'BANK_TRANSFER',
}

export const EXCEL_FILE = 'excelFile';
export const PROOF_FILES = 'proofFile';
export const FILES = 'nextFile';

export const JSON_DATA = 'jsonData';

export const URL_PATHS = {
	BILLING_PAYMENT_ROOT: 'dashboard/payments/billing-payment-track',
	REGISTER_NEW_PAYMENT: 'dashboard/payments/register-billing-payment',
};
